import React from 'react';
import {
  CostPerCharFromFlagFeature,
  ConcurrentCCRFeature,
} from './SharedApiFeatures';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'tts-sync';

const ttsRealtimeFeatures = ({ packages, ttsConfig }) => ({
  enabled: {
    key: 'tts-realtime-enabled',
    label: 'ttsRealtime',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerCharacter: {
    key: 'tts-realtime-cost-per-char',
    label: 'costPerCharacter',
    values: packages.map((pkg) => (
      <CostPerCharFromFlagFeature
        key={pkg.code}
        pkg={pkg}
        creditPerChar={ttsConfig?.creditPerChar}
        featureName={FEATURE_NAME}
      />
    )),
    tooltipContent: 'tooltipBasicVoice',
  },
  concurrentCCR: {
    key: 'tts-realtime-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.tts?.sync}
      />
    )),
  },
});

export default ttsRealtimeFeatures;
